export const environment = {
  production: false,
  env: 'stg',
  version: 'stg-57f5e668',
  feedbackDelay: 5000,
  api: 'https://stg.api.roz.copec.cl',
};
